function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "updated");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 833.81,
  y: 468.45001,
  width: 2,
  height: 197,
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M876.5,342.11241V545.88829a143.58356,143.58356,0,0,1,40.65966-52.13781c.351-.28768.7077-.56959,1.06441-.84574q5.31617-4.19432,11.02936-7.87649c.2474-.15535.49479-.31646.74219-.466a142.35956,142.35956,0,0,1,76.68207-22.26588H1158.31V342.11241Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#d0cde1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1123.11299,
  y: 389.19948,
  width: 23.22219,
  height: 23.22219,
  transform: "translate(2227.75817 721.71079) rotate(-180)",
  opacity: 0.1
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 888.21164,
  y: 377.58838,
  width: 190.68988,
  height: 5.80555,
  transform: "translate(1925.42316 681.07196) rotate(-180)",
  fill: "#f2f2f2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 888.21164,
  y: 392.32554,
  width: 190.68988,
  height: 5.80555,
  transform: "translate(1925.42316 710.54627) rotate(-180)",
  fill: "#f2f2f2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 888.21164,
  y: 407.0627,
  width: 190.68988,
  height: 5.80555,
  transform: "translate(1925.42316 740.02059) rotate(-180)",
  fill: "#f2f2f2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1111.05532,377.1418h35.72644v35.72644h-35.72644Zm34.83328.89316h-33.94012v33.94012h33.94012Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "1087.294 323.023 1076.161 310.038 1077.908 308.54 1087.108 319.27 1111.573 284.241 1113.459 285.558 1087.294 323.023",
  fill: "#ff3860"
});

var _ref11 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 834.81,
  cy: 468.45001,
  r: 23,
  fill: "#ff3860"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 376.81,
  y: 466.45001,
  width: 2,
  height: 197,
  fill: "#3f3d56"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 488.81,
  y: 351.45001,
  width: 2,
  height: 197,
  fill: "#3f3d56"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M932.57782,753.36036h-592s-12-142.96739,59-144.592,63,63.36055,152-25.99407,197-84.48074,211-31.68028-27,95.04083,48,82.04379S993.57782,654.258,932.57782,753.36036Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ff3860"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M626.58466,753.39289l-1.99805-.065c4.65967-94.12856,28.92822-154.60714,48.46631-188.7664,21.21387-37.09082,41.65625-52.10595,41.86035-52.2535l1.3291,1.21411c-.20117.146-20.40527,15.012-41.44922,51.8517C655.363,599.38864,631.22724,659.61892,626.58466,753.39289Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M840.84442,753.58724l-1.91992-.45375c23.11914-64.46,77.56152-105.15827,78.10938-105.562l1.34375,1.20261C917.83466,649.17465,863.7995,689.58493,840.84442,753.58724Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M433.8205,753.47222l-1.98145-.22371a148.36822,148.36822,0,0,0-19.59228-103.42258c-14.36573-23.62218-30.75684-36.524-30.9209-36.65174l1.38379-1.17246c.1665.12931,16.811,13.22947,31.33008,37.1047A149.73,149.73,0,0,1,433.8205,753.47222Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 603.47929,
  cy: 673.53494,
  rx: 417.5,
  ry: 9.69734,
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 603.47929,
  cy: 705.61075,
  rx: 289.03846,
  ry: 6.71354,
  fill: "#3f3d56"
});

var _ref20 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 603.61136,
  cy: 734.70276,
  rx: 235.78148,
  ry: 5.47653,
  fill: "#3f3d56"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 649.6688,
  y: 52.80049,
  width: 84.59303,
  height: 105.10043,
  fill: "#2f2e41"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M814.3959,408.02229s28.28766,41.14569,14.14383,51.43211-28.28766-45.0031-28.28766-45.0031Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ffb8b8"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M819.53911,413.1655l-21.85865,9.00062L764.24959,321.8735l.56575-4.56458,12.29227-98.29965s8.65343-.78432,13.03806,5.02746a12.72311,12.72311,0,0,1,2.39158,6.54477c1.2858,12.858-5.14321,83.57718-5.14321,83.57718s1.2858,7.71482,2.5716,10.28643,3.85741,1.2858,2.57161,5.14321-3.85741,3.85741-2.57161,5.14321a18.49646,18.49646,0,0,1,2.57161,3.85741Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#d0cde1"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M634.3835,459.4544,597.09522,546.889s-21.85865,46.2889-33.43087,105.43583l-14.14383,39.85989,24.43025,5.14321,6.429-10.28642,5.14322-24.43025s42.43149-64.29014,45.00309-96.43522l70.71916-96.43521Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ffb8b8"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M732.10452,468.455v95.14941s-7.71482,57.86113-5.14322,84.863v51.43211h19.287s0-21.85865,3.85741-29.57347,25.716-87.43459,19.287-115.72225l20.57284-95.14941Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ffb8b8"
});

var _ref26 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 691.70032,
  cy: 64.52236,
  r: 34.71668,
  fill: "#ffb8b8"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M707.67426,156.00494s1.28581,39.85988-2.5716,45.0031,47.5747,12.858,47.5747,12.858-16.71544-33.43087-5.14321-45.0031Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ffb8b8"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M773.25021,291.01423s-1.28581,11.57223,2.5716,16.71544-4.50031,9.64352-4.50031,9.64352c-2.63588-.43721-1.15725-.01287-6.50616-.06427l12.29227-98.29965s2.68729-2.59726,7.07192,3.21451c.07715,9.52784-5.78611,34.07378-5.78611,34.07378C787.394,279.442,773.25021,291.01423,773.25021,291.01423Z",
  transform: "translate(-41.69 -79.91035)",
  opacity: 0.1
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M748.81995,192.00742s-41.14569-10.28643-43.71729-9.00062-3.85741,15.42963-3.85741,15.42963-42.43149-3.85741-38.57409,10.28642S684.52981,320.5877,684.52981,320.5877s73.29076-5.14321,88.7204-2.57161a10.21364,10.21364,0,0,0-1.28581-10.28642c-3.85741-5.14321-2.5716-16.71544-2.5716-16.71544s14.14383-11.57222,5.14321-34.71667c0,0,16.71544-32.14507,10.28642-36.00248s-30.85927-11.57223-30.85927-11.57223S753.96316,190.72161,748.81995,192.00742Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#d0cde1"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.81561,316.73029,663.957,397.73587s-56.57533,56.57532-36.00248,65.57594,100.29262,24.43025,114.43645,14.14383,5.14321-12.858,23.14445-10.28642,50.14631,0,50.14631-10.28642-45.0031-144.00992-45.0031-144.00992Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M570.09336,684.46989s-16.71544-7.71481-20.57284-2.5716-41.14569,68.14755-20.57285,72.005,41.14569-6.429,43.7173-18.00124,18.00124-32.14507,18.00124-32.14507,16.665-19.36906-5.81132-37.97219C584.85489,665.78475,580.37978,684.46989,570.09336,684.46989Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#2f2e41"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M719.24649,697.32792s16.71543-16.71543,29.57346,0c0,0,19.287,60.43273-10.28642,59.14693s-25.71606-12.858-25.71606-12.858Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#2f2e41"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M625.38288,404.16488s-23.14445,52.71792-6.429,54.00372,20.57284-48.86051,20.57284-48.86051Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#ffb8b8"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M673.60049,199.07933s-18.64414,1.92871-19.93,12.21513-10.28642,88.72039-10.28642,88.72039L620.23967,408.02229l24.43025,5.14321s16.71544-68.14755,25.71606-78.434l7.71482-70.71916Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#d0cde1"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M739.17056,89.17138s-33.32453-2.06587-41.01481,18.65683-21.14825,31.60211-21.14825,31.60211-21.19961,14.73616-10.59981,41.04246c0,0-32.97842,22.16175-11.18931,41.84831,0,0-1.28171,19.68656,11.53542,33.15631,0,0,10.2537,5.18068,6.40856,8.28908s25.63425,1.03614,23.07083-26.9395,14.73969-47.682,14.73969-47.682-16.66226-36.27146-8.972-48.70508c4.6691-7.549,6.67423-13.17845,10.55025-16.43653a48.62507,48.62507,0,0,0,5.9835-5.83948,13.80643,13.80643,0,0,1,14.86821-4.63692c11.53541,3.1084,14.09884,12.43361,14.09884,12.43361s8.33113,22.2769,22.43,32.63825-10.89456,28.4937-10.89456,28.4937,4.34441,21.34819,15.63019,33.98713-3.25242,23.65593-4.09478,25.07255c-1.92257,3.23326-9.6005,23.65022,22.11572,23.74066,0,0,7.36367-15.45158,17.61737-24.77679s2.56343-36.26472,2.56343-36.26472,15.38055-9.32521-1.28172-32.12017c0,0,5.12685-20.7227-8.972-34.19245C802.61533,142.53872,782.74878,81.91844,739.17056,89.17138Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#2f2e41"
});

var _ref36 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 659.67003,
  cy: 57.84956,
  rx: 3.20428,
  ry: 5.12685,
  fill: "#ffb8b8"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M531.5,79.91035v354.18a249.56052,249.56052,0,0,0-70.67-90.62c-.61005-.5-1.23-.99-1.85-1.47q-9.24-7.29008-19.17-13.69c-.43-.27-.86-.55-1.29-.81a247.43325,247.43325,0,0,0-133.28-38.7H41.69v-208.89Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#3f3d56"
});

var _ref38 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20.81326,
  y: 81.84137,
  width: 40.36216,
  height: 40.36216,
  opacity: 0.1
});

var _ref39 =
/*#__PURE__*/
React.createElement("rect", {
  x: 138.01876,
  y: 61.66029,
  width: 331.4354,
  height: 10.09054,
  fill: "#f2f2f2"
});

var _ref40 =
/*#__PURE__*/
React.createElement("rect", {
  x: 138.01876,
  y: 87.27474,
  width: 331.4354,
  height: 10.09054,
  fill: "#f2f2f2"
});

var _ref41 =
/*#__PURE__*/
React.createElement("rect", {
  x: 138.01876,
  y: 112.88918,
  width: 331.4354,
  height: 10.09054,
  fill: "#f2f2f2"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M123.8227,202.89007H61.72707V140.79445H123.8227Zm-60.54324-1.55239h58.99085V142.34684H63.27946Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref43 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "50.972 105.711 31.622 83.143 34.659 80.54 50.648 99.189 93.17 38.305 96.45 40.595 50.972 105.711",
  fill: "#ff3860"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M419.5,340.11241V543.88829a143.58356,143.58356,0,0,0-40.65966-52.13781c-.351-.28768-.7077-.56959-1.06441-.84574q-5.31616-4.19432-11.02936-7.87649c-.2474-.15535-.49479-.31646-.74219-.466a142.35956,142.35956,0,0,0-76.68207-22.26588H137.69V340.11241Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#d0cde1"
});

var _ref45 =
/*#__PURE__*/
React.createElement("rect", {
  x: 107.97482,
  y: 307.28912,
  width: 23.22219,
  height: 23.22219,
  opacity: 0.1
});

var _ref46 =
/*#__PURE__*/
React.createElement("rect", {
  x: 175.40848,
  y: 295.67803,
  width: 190.68988,
  height: 5.80555,
  fill: "#f2f2f2"
});

var _ref47 =
/*#__PURE__*/
React.createElement("rect", {
  x: 175.40848,
  y: 310.41519,
  width: 190.68988,
  height: 5.80555,
  fill: "#f2f2f2"
});

var _ref48 =
/*#__PURE__*/
React.createElement("rect", {
  x: 175.40848,
  y: 325.15234,
  width: 190.68988,
  height: 5.80555,
  fill: "#f2f2f2"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M184.94468,410.86824H149.21824V375.1418h35.72644Zm-34.83328-.89316h33.94012V376.035H150.1114Z",
  transform: "translate(-41.69 -79.91035)",
  fill: "#f2f2f2"
});

var _ref50 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "125.326 321.023 114.194 308.038 115.941 306.54 125.14 317.27 149.605 282.241 151.492 283.558 125.326 321.023",
  fill: "#ff3860"
});

var _ref51 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 489.81,
  cy: 351.45001,
  r: 32,
  fill: "#ff3860"
});

var _ref52 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 377.81,
  cy: 466.45001,
  r: 23,
  fill: "#ff3860"
});

var SvgAsyncUpdate = function SvgAsyncUpdate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "b2056295-6b1e-4566-b96a-9db5328c1149",
    "data-name": "Layer 1",
    width: 1116.62,
    height: 740.1793,
    viewBox: "0 0 1116.62 740.1793",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAsyncUpdate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/async-update.8114da23.svg";
export { ForwardRef as ReactComponent };